import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Guard que impede acesso direto por URL (ex.: digitando na barra de endereço).
 * Exige que haja um estado de navegação (`state`) fornecido pelo Router,
 * o que só ocorre quando a navegação é feita programaticamente pela aplicação.
 */
export const navigationStateGuard: CanActivateFn = (_route, _state) => {
  const router = inject(Router);

  const navigation = router.getCurrentNavigation();
  const navigationState = navigation?.extras?.state;

  if (navigationState && Object.keys(navigationState).length > 0) {
    return true;
  }

  // Acesso direto via URL sem estado de navegação — redireciona para a listagem
  router.navigate(['/profissional-homol']);
  return false;
};


